import { useCallback, useEffect, useMemo, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import en from '../../../lang/en-us';
import { CustomRadio } from '../../../lib/CustomRadio';
import { TableColumn, TableWithCollapse } from '../../../lib/DataTable';
import SegmentedControl from '../../common/segmented-control';
import { connect } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { getPortfolio } from '../../../redux-store/actions/portfolio';
import { dematFund } from '../portfolios/utils';
import {
    IsAllow,
    PORTFOLIO_DATA_RESPONSE,
    SCHEMES_RESPONSE,
} from '../../../redux-store/types/portfolio';
import { formatAsIndianCurrency } from '../../../utils/currency';
import moment from 'moment';
import { Button, Dialog } from '@material-ui/core';
import {
    downloadSummaryPDF,
    generateDetailedPDF,
    downloadDetailedPDF,
    getCasHistory,
} from '../../../redux-store/actions/nct';
import { LIST_PROTFOLIO_PAYLOAD } from '../../../redux-store/types/portfolio';
import DatePickerInput from '../../../lib/DatePicker';
import { useTableWithCollapse } from '../../../lib/DataTable/customHooks';
import { CAS_HISTORY_DATA } from '../../../redux-store/types/nct';
import NoFoliosFound from '../makeNct/NoFoliosFound';
import { ALL_HOLDINGS, getDateString, TRANSACTION_RESOURCE_TYPES } from '../../../utils/constants';
import HoldingTypeRadio from '../../../lib/HoldingTypeRadio';
import { getHoldingTypeValue, maskPan } from '../../../utils/utilityFunctions';
import { fileDownload } from '../../../lib/FileDownload';
import SegmentedControlLarge from '../../common/segemented-control-large';

const { dashboard, sebi } = en;

const SEGMENTS = ['Summary ', 'Detailed ', 'My Downloads'];
const SEGMENTSSPAN = ['(Only balances & Valuation)', '(Includes transaction listing)'];

const CURRENT_FINANCIAL_YEAR = 'CURRENT_FINANCIAL_YEAR';
const PREVIOUS_FINANCIAL_YEAR = 'PREVIOUS_FINANCIAL_YEAR';
const SPECIFIC_FINANCIAL_YEAR = 'SPECIFIC_FINANCIAL_YEAR';

const columns: TableColumn[] = [
    {
        headerName: 'Nature of Holding',
        field: 'name',
    },
    {
        headerName: 'Cost Value(Rs.)',
        field: 'costValue',
        valueGetter: ({ value }) => formatAsIndianCurrency(Number(value)) || 'N/A',
    },
    {
        headerName: 'Market Value(Rs.)',
        field: 'currentMktValue',
        valueGetter: ({ value }) => formatAsIndianCurrency(Number(value)) || 'N/A',
    },
];

const columns1: TableColumn[] = [
    {
        headerName: 'Scheme Name',
        field: 'schemeName',
    },
    {
        headerName: 'Invested Value(Rs.)',
        field: 'costValue',
        valueGetter: ({ value }) => formatAsIndianCurrency(Number(value)) || 'N/A',
    },
    {
        headerName: 'Market Value(Rs.)',
        field: 'currentMktValue',
        valueGetter: ({ value }) => formatAsIndianCurrency(Number(value)) || 'N/A',
    },
    {
        headerName: 'Gain/Loss(Absolute)(Rs.)',
        field: 'gainLoss',
        valueGetter: ({ row, value }) =>
            `${formatAsIndianCurrency(Number(value)) ?? 0}(${row.gainLossPercentage || 0}%)`,
    },
    {
        headerName: 'Balance Units',
        field: 'closingBalance',
    },
    {
        headerName: 'Nav Date',
        field: 'navDate',
        valueGetter: ({ row }) => getDateString(row.navDate),
    },
];

type CAS_DETAIL_PDF = {
    pan: string;
    mobile: string;
    fileType: string;
    pekrn: string;
    reqId: string;
    fromDate: string;
    toDate: string;
};

type CAS_SINGLE_DETAIL_PDF = {
    pan: string;
    mobile: string;
    pekrn: string;
    reqId: string;
    documentId: string;
};
interface SebiCasProps extends RouteComponentProps {
    pan: string;
    mobile: string;
    pekrn: string;
    reqId: string;
    portfolios: any;
    getPortfolio: Function;
    downloadSummaryPDF: Function;
    generateDetailedPDF: Function;
    downloadDetailedPDF: Function;
    getCasHistory: Function;
    casDetail?: 'Y' | 'N';
    newToMF: IsAllow;
}

const CustomDownloadButton = ({ row, downloadCasDetailedPDF }: any) => {
    const isDocumentReadyToDownload = row.requestStatus === 'Completed';
    const downloadStatus = () => (row.isDownloading ? () => { } : downloadCasDetailedPDF(row));
    const color = isDocumentReadyToDownload ? '#33dbb3' : '#2D9CDB';
    return (
        <div
            className="sebi-download"
            role="button"
            style={isDocumentReadyToDownload ? { cursor: 'pointer', color } : { color }}
            onClick={isDocumentReadyToDownload ? () => downloadStatus() : () => { }}
        >
            <img
                src={`/images/${isDocumentReadyToDownload ? 'download-icon.svg' : 'inprogress_icon.svg'
                    }`}
                alt="icon"
            />
            {isDocumentReadyToDownload
                ? row.isDownloading
                    ? 'Downloading'
                    : 'Download'
                : 'In Progress'}
        </div>
    );
};

const ComingSoon = (): JSX.Element => {
    return (
        <div
            className={`folios-not-found `}
            style={{
                marginTop: 20,
            }}
        >
            <img
                className="nct-coming-soon"
                src="/images/coming-soon.svg"
                alt="icon"
                style={{
                    width: 270,
                    height: 250,
                }}
            />
        </div>
    );
};

export default function SebiCas(props: SebiCasProps) {
    const [statementType, setType] = useState(SEGMENTS[0]);
    const [period, setPeriod] = useState<string>(CURRENT_FINANCIAL_YEAR);
    const [showDialog, setShowDialog] = useState<boolean>(false);
    const [isDemat, setIsDemat] = useState<boolean>(false);
    const [selectedDate, setSelectedDate] =
        useState<{
            from: Date | string | undefined;
            to: Date | string | undefined;
        } | null>(null);

    const [isDownloadingSummaryPDF, setIsDownloadingSummaryPDF] = useState<boolean>(false);
    const [isGeneratingDetailedPDF, setIsGeneratingDetailedPDF] = useState<boolean>(false);
    const [isGeneratingDetailedExcel, setIsGeneratingDetailedExcel] = useState<boolean>(false);
    const [isDownloadingDetailedPDF, setIsDownloadingDetailedPDF] = useState<boolean>(false);

    const [isCasHistoryDataLoading, setIsCasHistoryDataLoading] = useState<boolean>(false);
    const [casHistoryData, setCasHistoryData] = useState<CAS_HISTORY_DATA[]>([]);
    const [holdingType, setHoldingType] = useState<string>(ALL_HOLDINGS);

    const downloadColumns: TableColumn[] = [
        {
            headerName: 'S.NO',
            field: 'id',
            valueGetter: ({ index = 0 }) =>
                (index + 1).toLocaleString('en-US', {
                    minimumIntegerDigits: 2,
                    useGrouping: false,
                }),
        },
        {
            headerName: 'Requested Date & Time',
            field: 'requestDateTime',
            valueGetter: ({ row }) => moment(row.requestDateTime).format('DD-MM-YYYY hh:mm A'),
        },
        {
            headerName: 'From Date',
            field: 'fromDate',
            valueGetter: ({ row }) =>
                row.fromDate !== '' ? moment(row.fromDate).format('DD-MM-YYYY') : 'N/A',
        },
        {
            headerName: 'To Date',
            field: 'toDate',
            valueGetter: ({ row }) =>
                row.toDate !== '' ? moment(row.toDate).format('DD-MM-YYYY') : 'N/A',
        },
        {
            headerName: 'Action',
            field: 'requestStatus',
            renderCell: ({ row }) => (
                <CustomDownloadButton
                    row={row}
                    isDownloadingDetailedPDF={isDownloadingDetailedPDF}
                    downloadCasDetailedPDF={downloadCasDetail}
                />
            ),
        },
    ];

    const { tableRows, tableColumns, ...rest } = useTableWithCollapse<CAS_HISTORY_DATA[]>({
        rows: casHistoryData,
        columns: downloadColumns,
        loading: isCasHistoryDataLoading,
    });

    const handleSegmentChange = (selectedSegmentIndex: number) => {
        setType(SEGMENTS[selectedSegmentIndex]);
        setIsDemat(false);
    };

    useEffect(() => {
        const fetchPortfolio = async () => {
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan,
                mobile,
                pekrn,
                reqId,
            };
            try {
                await props.getPortfolio(payload);
            } catch (error: any) {
                alert(error.message);
            }
        };
        fetchPortfolio();
    }, []);

    useEffect(() => {
        if (statementType === SEGMENTS[2]) {
            const fetchCasHistory = async () => {
                setIsCasHistoryDataLoading(true);
                try {
                    const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
                    const payload: LIST_PROTFOLIO_PAYLOAD = {
                        pan,
                        mobile,
                        pekrn,
                        reqId,
                    };
                    const { body: casHistoryData = {} } = await props.getCasHistory(payload);
                    const { history: casHistory = [] } = casHistoryData || {};
                    setCasHistoryData(
                        casHistory.map((obj: {}) => ({ ...obj, isDownloading: false })).reverse(),
                    );
                } catch (error: any) {
                    alert(error);
                } finally {
                    setIsCasHistoryDataLoading(false);
                }
            };
            fetchCasHistory();
        }
    }, [statementType]);

    useEffect(() => {
        let fromDate = new Date();
        let toDate = new Date();
        switch (period) {
            case CURRENT_FINANCIAL_YEAR: {
                const currentMonth = new Date().getMonth();
                const currentYear = new Date().getFullYear();
                if (currentMonth > 2) {
                    fromDate = new Date(`04/01/${currentYear}`);
                } else {
                    fromDate = new Date(`04/01/${currentYear - 1}`);
                }
                break;
            }
            case PREVIOUS_FINANCIAL_YEAR: {
                const currentMonth = new Date().getMonth();
                const currentYear = new Date().getFullYear();
                if (currentMonth > 2) {
                    fromDate = new Date(`04/01/${currentYear - 1}`);
                    toDate = new Date(`03/31/${currentYear}`);
                } else {
                    fromDate = new Date(`04/01/${currentYear - 2}`);
                    toDate = new Date(`03/31/${currentYear - 1}`);
                }
                break;
            }
            default: {
            }
        }
        setSelectedDate({ from: fromDate, to: toDate });
    }, [period]);

    const { fundsByDematAndNonDemat = [], dematAndNonDematSummary = [] } = useMemo(() => {
        const { data = [], portfolio = {} } = props.portfolios;
        let amcData = data.reduce((prev: SCHEMES_RESPONSE[], fund: PORTFOLIO_DATA_RESPONSE) => {
            const { schemes, ...rest } = fund;
            schemes.forEach((scheme: SCHEMES_RESPONSE) => {
                let _isDematFund = dematFund(scheme);
                if (isDemat === _isDematFund) {
                    prev = [...prev, scheme];
                }
            });
            return prev;
        }, []);

        // sort by a-z
        amcData.sort((first: any, second: any) => {
            let amcName1 = first.amcName.toUpperCase();
            let amcName2 = second.amcName.toUpperCase();
            if (amcName1 < amcName2) {
                return -1;
            }
            if (amcName1 > amcName2) {
                return 1;
            }

            return 0;
        });

        return {
            fundsByDematAndNonDemat: amcData,
            dematAndNonDematSummary: [
                { ...portfolio.demat, name: 'Demat Holdings' },
                { ...portfolio.non_demat, name: 'Non-Demat Holdings' },
            ],
        };
    }, [props.portfolios, isDemat]);

    const amcData = useMemo(() => {
        // sort by closing balance
        return fundsByDematAndNonDemat.filter((scheme: any) => {
            const value = Number(scheme.closingBalance);
            if (holdingType === 'zeroHoldings') {
                return value == 0;
            } else if (holdingType === 'nonZeroHoldings') {
                return value > 0;
            } else {
                return true;
            }
        });
    }, [holdingType, fundsByDematAndNonDemat]);

    const toggleDialog = () => {
        setShowDialog((show) => !show);
        setPeriod(CURRENT_FINANCIAL_YEAR);
        // setSelectedDate({
        //     from: new Date(),
        //     to: new Date(),
        // });
        handleSegmentChange(2);
    };

    const DematSegment = useCallback(
        () => (
            <SegmentedControl
                additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
                segments={TRANSACTION_RESOURCE_TYPES}
                onSegmentChanged={(index) => setIsDemat(Boolean(index))}
                selectedSegmentIndex={isDemat ? 1 : 0}
            />
        ),
        [isDemat],
    );

    const downloadCasSummaryPDF = async () => {
        if (props.newToMF === IsAllow.YES && !amcData.length) {
            alert(en.sebi.noFoliosToDownload);
            return;
        }
        try {
            setIsDownloadingSummaryPDF(true);
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            const payload: LIST_PROTFOLIO_PAYLOAD = {
                pan,
                mobile,
                pekrn,
                reqId,
                statementHoldingFilter: getHoldingTypeValue(holdingType),
            };
            const response = await props.downloadSummaryPDF(payload);
            return fileDownload({
                data: response.body,
                filename: `cas_summary_report_${moment().format('YYYY_MM_DD_HHmmss')}.pdf`,
            });
        } catch (error: any) {
            alert(error.message);
        } finally {
            setIsDownloadingSummaryPDF(false);
        }
    };

    const generateCasDetail = async (fileType: 'pdf' | 'xlsx') => {
        if (props.newToMF === IsAllow.YES && !amcData.length) {
            alert(en.sebi.noFoliosToDownload);
            return;
        }
        try {
            if (fileType === 'pdf') {
                setIsGeneratingDetailedPDF(true);
            } else {
                setIsGeneratingDetailedExcel(true);
            }
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            const fromDate = moment(selectedDate?.from).format('YYYY-MM-DD');
            const toDate = moment(selectedDate?.to).format('YYYY-MM-DD');
            if (fromDate === toDate) {
                throw Error('From date and To date should not be same');
            }
            const payload: CAS_DETAIL_PDF = {
                pan,
                mobile,
                pekrn,
                fileType,
                reqId,
                fromDate: moment(fromDate).format('DD-MMM-YYYY'),
                toDate: moment(toDate).format('DD-MMM-YYYY'),
            };
            const { error } = await props.generateDetailedPDF(payload);
            if (error === null) toggleDialog();
        } catch (error: any) {
            alert(error.message);
        } finally {
            if (fileType === 'pdf') {
                setIsGeneratingDetailedPDF(false);
            } else {
                setIsGeneratingDetailedExcel(false);
            }
        }
    };
    const downloadCasDetail = async (clickedRow: any) => {
        const clickedDoc = casHistoryData.filter(
            (row) => row.documentId == clickedRow.documentId,
        )[0];
        clickedDoc.isDownloading = true;
        setCasHistoryData([...casHistoryData]);
        try {
            const { pan = '', pekrn = '', mobile = '', reqId = '' } = props;
            const payload: CAS_SINGLE_DETAIL_PDF = {
                pan,
                pekrn,
                mobile,
                reqId,
                documentId: clickedRow.documentId,
            };
            const response = await props.downloadDetailedPDF(payload);
            // filename:`cas_detailed_report_${moment().format('YYYY_MM_DD_HHmmss')}.pdf`
            return fileDownload({
                data: response.body,
                mime: clickedRow.fileType === 'pdf' ? 'application/pdf' : 'application/vnd.ms-excel',
                filename: `cas_detailed_report_${moment().format('YYYY_MM_DD_HHmmss')}.${clickedRow.fileType}`,
            });
        } catch (error) {
            alert(error);
        } finally {
            clickedDoc.isDownloading = false;
            setCasHistoryData([...casHistoryData]);
        }
    };

    const handleFromDateChange = (date: Date) => {
        setSelectedDate((prev) => ({
            from: date,
            to: prev?.to,
        }));
    };

    const handleToDateChange = (date: Date) => {
        setSelectedDate((prev) => ({
            from: prev?.from,
            to: date,
        }));
    };


    return (
        <div className="curved-bg-content curved-bg-table-outer sebi-cas">
            <div className="sebi-content-bottom">
                <SegmentedControl
                    additionalClasses="portfolio-details-tabs portfolio-details-main-tab"
                    segments={SEGMENTS}
                    segmentsSpan={SEGMENTSSPAN}
                    onSegmentChanged={handleSegmentChange}
                    selectedSegmentIndex={SEGMENTS.findIndex(
                        (str: string) => str === statementType,
                    )}
                    key={statementType}
                />
            </div>
            {statementType === SEGMENTS[0] ? (
                <>
                    <div className="sebi-content-bottom">
                        <div className="sebi-content-left">
                            <p className="sebi-content-left-text">{sebi.period}</p>
                        </div>
                        <div className="sebi-content-right">
                            <div className="sebi-content-period">
                                <div className="sebi-content-period-left">
                                    <img
                                        src="/images/calendar.svg"
                                        style={{
                                            marginRight: 13,
                                        }}
                                    />
                                    <p className="sebi-content-text">
                                        As on {moment(new Date()).format('ll')}
                                    </p>
                                </div>
                                <div className="sebi-content-disclaimer">
                                    <p className="sebi-content-disclaimer-text">
                                        {sebi.periodDisclaimer}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="sebi-portfolio-summary">
                        <div className="sebi-portfolio-summary-top">
                            <h3>{sebi.table.head}</h3>
                            <p>
                                PAN : <span>{maskPan(props.pan)}</span>
                            </p>
                        </div>
                        <div className="sebi-portfolio-summary-bottom">
                            <TableWithCollapse
                                rows={dematAndNonDematSummary}
                                columns={columns}
                            ></TableWithCollapse>
                        </div>
                    </div>
                    <div className="sebi-portfolio-units">
                        <DematSegment />
                        <HoldingTypeRadio
                            selectedValue={holdingType}
                            handleRadioChange={(value: any) => setHoldingType(value)}
                        />
                        {isDemat && (
                            <div className="demat-holding-note sebi-demat-note">
                                <p>{dashboard.dematHoldingNote.info1}</p>
                                <p>{dashboard.dematHoldingNote.info2}</p>
                            </div>
                        )}
                        <TableWithCollapse rows={amcData} columns={columns1} />
                    </div>
                    <div className="sebi-download-btn">
                        {isDownloadingSummaryPDF ? (
                        <a className="customBtn">
                            {sebi.downloading}
                            <span className="sending-dots">
                                <i></i>
                                <i></i>
                                <i></i>
                            </span>
                        </a>
                        ) : (
                        <a onClick={downloadCasSummaryPDF}>{sebi.modal.download}</a>
                        )}
                    </div>
                </>
            ) : statementType === SEGMENTS[1] ? (
                <>
                    <>
                        <div className="sebi-content-bottom detailed-sebi-period">
                            <div className="sebi-content-right">
                                <div className="sebi-content-heading sebi-content-folioListing">
                                    <p>{sebi.selectPeriod}</p>
                                </div>
                                <CustomRadio
                                    title={''}
                                    name="select-period"
                                    list={[
                                        {
                                            label: 'Current financial year',
                                            value: CURRENT_FINANCIAL_YEAR,
                                            cssClass: 'sebi-radio-button-style',
                                        },
                                        {
                                            label: 'Previous financial year',
                                            value: PREVIOUS_FINANCIAL_YEAR,
                                            cssClass: 'sebi-radio-button-style',
                                        },
                                        {
                                            label: 'Specific period ',
                                            value: SPECIFIC_FINANCIAL_YEAR,
                                            cssClass: 'sebi-radio-button-style',
                                        },
                                    ]}
                                    selectedValue={period}
                                    handleRadioChange={(value: any) => setPeriod(value)}
                                />
                                <div
                                    className="sebi-content-period sebi-detailed-content"
                                    style={{ marginTop: '-20px', marginBottom: '30px' }}
                                >
                                    <h6>From</h6>
                                    <div className="sebi-content-period-left">
                                        {period === SPECIFIC_FINANCIAL_YEAR ? (
                                            <DatePickerInput
                                                value={selectedDate?.from ?? new Date()}
                                                onChange={(date: any) =>
                                                    handleFromDateChange(date)
                                                }
                                                minDate={moment()
                                                    .subtract(3, 'years')
                                                    .startOf('year')
                                                    .format('YYYY-MM-DD')}
                                            />
                                        ) : (
                                            <p className="sebi-content-text">
                                                {moment(selectedDate?.from).format(
                                                    'YYYY-MM-DD',
                                                )}
                                            </p>
                                        )}
                                    </div>
                                    <h6>To</h6>
                                    <div className="sebi-content-period-left">
                                        {period === SPECIFIC_FINANCIAL_YEAR ? (
                                            <DatePickerInput
                                                value={selectedDate?.to ?? new Date()}
                                                onChange={(date: any) =>
                                                    handleToDateChange(date)
                                                }
                                                minDate={selectedDate?.from ?? new Date()}
                                            />
                                        ) : (
                                            <p className="sebi-content-text">
                                                {moment(selectedDate?.to).format('YYYY-MM-DD')}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sebi-content-bottom sebi-content-period-pan">
                            <div className="sebi-content-left" style={{ width: '10%' }}>
                                <p className="sebi-content-left-text">{sebi.pan}</p>
                            </div>
                            <div className="sebi-content-right">
                                <div className="sebi-content-period">
                                    <div className="sebi-content-period-left">
                                        <p className="sebi-content-text">
                                            {maskPan(props.pan)}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div className="sebi-download-btn" style={{ flex: '50%' }}>
                                {isGeneratingDetailedExcel ? (
                                    <a className="customBtn">
                                        {sebi.submitting}
                                        <span className="sending-dots">
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                        </span>
                                    </a>
                                ) : (
                                    <a onClick={() => generateCasDetail('xlsx')}>{sebi.submitExcel}</a>
                                )}
                            </div>
                            <div className="sebi-download-btn" style={{ flex: '50%' }}>
                                {isGeneratingDetailedPDF ? (
                                    <a className="customBtn">
                                        {sebi.submitting}
                                        <span className="sending-dots">
                                            <i></i>
                                            <i></i>
                                            <i></i>
                                        </span>
                                    </a>
                                ) : (
                                    <a onClick={() => generateCasDetail('pdf')}>{sebi.submitPdf}</a>
                                )}
                            </div>
                        </div>
                    </>
                </>
            ) : (
                <>
                    <div className="sebi-portfolio-downloads">
                        {!!tableRows.length || isCasHistoryDataLoading ? (
                            <TableWithCollapse
                                columns={tableColumns}
                                rows={tableRows}
                                {...rest}
                            />
                        ) : (
                            <NoFoliosFound info={'No Downloads Found'} />
                        )}
                    </div>
                </>
            )}
            <Dialog maxWidth={'sm'} open={showDialog} aria-labelledby="sebi-modal">
                <div className="sebi-modal">
                    <h3>{sebi.modal.note}</h3>
                    <ul>
                        <li>
                            <p>{sebi.modal.info1}</p>
                        </li>
                        <li>
                            <p>{sebi.modal.info2}</p>
                        </li>
                    </ul>
                    <div className="note-modals-btns">
                        <Button onClick={toggleDialog} className="customBtn">
                            {sebi.modal.download}
                        </Button>
                    </div>
                </div>
            </Dialog>
        </div>
    );
}
